import { Box, Checkbox, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import DataListingComponent from "../../Component/DataListingComponent";
import { API_GET, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import { toast } from "react-toastify";
import view from "../../Assets/View.png";
import BookingDetailsModal from "../BookingDetails/BookingDetailsModal";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import DraftsIcon from "@mui/icons-material/Drafts";
const PAGE_SIZE_OPTIONS = [15];

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const InquiryScreen = () => {
  const [data, setData] = useState();
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [open, setOpen] = useState(false);
  const [modalData, setModalData] = useState({});
  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "",
      headerName: "*",
      width: 50,
      headerAlign: "center",
      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            {isFollowup ? (
              <MarkunreadIcon
                style={{
                  color: "#164FA1",
                }}
              />
            ) : (
              <DraftsIcon />
            )}
          </Box>
        );
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "rowId",
      headerName: "Sr",
      width: 50,
      headerAlign: "center",
      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
            }}
          >
            {cell?.row?.rowId + page * rowsPerPage}
          </Box>
        );
      },
    },

    {
      headerClassName: "super-app-theme--header",
      field: "full_name",
      headerName: "User Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
            }}
          >
            {cell?.row?.full_name}
          </Box>
        );
      },
    },

    {
      headerClassName: "super-app-theme--header",
      field: "email",
      headerName: "Email",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
            }}
          >
            {cell?.row?.email}
          </Box>
        );
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "phno",
      headerName: "Number",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
            }}
          >
            {cell?.row?.phno}
          </Box>
        );
      },
    },
  
    {
      headerClassName: "super-app-theme--header",
      field: "total_budget",
      headerName: "Budget",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",

      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
            }}
          >
            {cell?.row?.total_budget}€
          </Box>
        );
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "from_date",
      headerName: "From Date",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
            }}
          >
            {cell?.row?.from_date}
          </Box>
        );
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "to_date",
      headerName: "To Date",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        const isFollowup = cell?.row?.is_followup === 0;
        return (
          <Box
            sx={{
              fontWeight: isFollowup ? "bold" : "normal",
            }}
          >
            {cell?.row?.to_date}
          </Box>
        );
      },
    },

    {
      headerClassName: "super-app-theme--header",
      field: "is_Active",
      headerName: "Read",
      width: 100,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <Checkbox
              {...label}
              style={{ color: "#F57C00" }}
              onChange={() =>
                handleContactAction(
                  cell?.row,
                  cell?.row?.is_followup === 1 ? 0 : 1
                )
              }
              checked={cell?.row?.is_followup}
            />
          </Box>
        </Box>
      ),
    },
    {
      headerClassName: "super-app-theme--header",
      field: "status",
      headerName: "View",
      width: 100,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              onClick={() => {
                setOpen(true);
                setModalData({
                  ...cell.row,
                  clickedFrom: 2,
                });
                cell?.row?.is_followup === 0 &&
                  handleContactAction(cell?.row, 1);
              }}
              className="ImgHover"
              src={view}
              alt="icon"
              height={24}
              width={24}
            />
          </Box>
        </Box>
      ),
    },
  ];
  const handleContactAction = async (data, status) => {
    try {
      const f = new FormData();
      f.append("id", data?.id);
      f.append("is_followup", status);

      const res = await API_POST(API_endspoints.updateInquiryFollowUP, f);
      if (res?.s) {
        // toast.success(res?.m);
        FetchContactData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const FetchContactData = async (
    page = 0,
    pageSize = PAGE_SIZE_OPTIONS[0]
  ) => {
    try {
      setIsLoading(true);
      let count = page * pageSize;
      const res = await API_GET(
        `${API_endspoints.GetInquiryList}?count=${count}&offset=${pageSize}`
      );
      if (res && res?.s) {
        const RowData = res?.r?.map((x, i) => {
          return {
            rowId: i + 1,
            ...x,
          };
        });
        setData(RowData);
        setTotalData(res?.c ?? 0);
      } else {
        setData([]);
        setTotalData(0);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    FetchContactData(page, rowsPerPage);
  }, [page, rowsPerPage]);

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };
  return (
    <Box sx={{ height: "calc(100vh - 32px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "start",
          px: 2,
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
        }}
      >
        {/* <Box> */}
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          Inquiry Management
        </Typography>
      </Box>
      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 130px)",
          width: "100%",
          p: 2,
        }}
      >
        <DataListingComponent
          data={data ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={true}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
        <BookingDetailsModal open={open} setOpen={setOpen} data={modalData} />
      </Box>
    </Box>
  );
};

export default InquiryScreen;
